import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_BACK_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-incline-bench-row",
    "name": "上斜凳支撑器械划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "machine",
    "pattern": "胸部支撑双臂水平拉",
    "legacyIds": [
      "incline-bench-row"
    ],
    "sourceId": "course-20261008-four-way-02-03",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-single-arm-dumbbell-row",
    "name": "单臂哑铃划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "dumbbell",
    "pattern": "单臂水平拉",
    "legacyIds": [
      "home-single-arm-dumbbell-row"
    ],
    "sourceId": "course-20261008-home-02-03",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-double-dumbbell-bent-row",
    "name": "双哑铃俯身划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "dumbbell",
    "pattern": "双臂俯身水平拉",
    "legacyIds": [
      "home-double-dumbbell-bent-row"
    ],
    "sourceId": "course-20261008-home-02-04",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-pull-up",
    "name": "正握引体向上",
    "group": "back",
    "subCategory": "width",
    "equipment": "bodyweight",
    "pattern": "闭链垂直拉",
    "legacyIds": [
      "home-pull-up"
    ],
    "sourceId": "course-20261008-home-02-02",
    "targetMuscles": [
      "背阔肌",
      "大圆肌",
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-single-arm-cable-pulldown",
    "name": "单臂绳索高位下拉",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "单臂垂直拉",
    "legacyIds": [
      "ksw-single-arm-cable-pulldown"
    ],
    "sourceId": "course-20261008-ksw-collection-02-06",
    "targetMuscles": [
      "背阔肌",
      "大圆肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-single-arm-machine-row",
    "name": "单臂器械划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "machine",
    "pattern": "单臂器械水平拉",
    "legacyIds": [
      "ksw-single-arm-machine-row"
    ],
    "sourceId": "course-20261008-ksw-collection-02-07",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-wide-grip-row",
    "name": "宽肘绳索划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "cable",
    "pattern": "高肘双臂水平拉",
    "legacyIds": [
      "ksw-wide-grip-row"
    ],
    "sourceId": "course-20261008-ksw-collection-02-09",
    "targetMuscles": [
      "菱形肌",
      "斜方肌中部",
      "三角肌后束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-back-extension",
    "name": "罗马椅背伸",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "bodyweight",
    "pattern": "罗马椅躯干伸展",
    "legacyIds": [
      "ksw-back-extension"
    ],
    "sourceId": "course-20261008-ksw-collection-03-14",
    "targetMuscles": [
      "竖脊肌",
      "臀大肌",
      "腘绳肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-neutral-pulldown",
    "name": "对握高位下拉",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "对握垂直拉",
    "legacyIds": [
      "threeway-neutral-pulldown"
    ],
    "sourceId": "course-20261008-personal-02-06",
    "targetMuscles": [
      "背阔肌",
      "大圆肌",
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-supinated-pulldown",
    "name": "反握高位下拉",
    "group": "back",
    "subCategory": "width",
    "equipment": "cable",
    "pattern": "反握垂直拉",
    "legacyIds": [
      "threeway-supinated-pulldown"
    ],
    "sourceId": "threeway-supinated-pulldown",
    "targetMuscles": [
      "背阔肌",
      "肱二头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-narrow-cable-row",
    "name": "坐姿窄距对握绳索划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "cable",
    "pattern": "坐姿窄距对握水平拉",
    "legacyIds": [
      "threeway-narrow-cable-row",
      "fanjue-seated-cable-row"
    ],
    "sourceId": "course-20261008-personal-02-07",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-tbar-row",
    "name": "T杆划船",
    "group": "back",
    "subCategory": "thickness",
    "equipment": "barbell",
    "pattern": "T杆双臂水平拉",
    "legacyIds": [
      "threeway-tbar-row"
    ],
    "sourceId": "threeway-tbar-row",
    "targetMuscles": [
      "背阔肌",
      "菱形肌",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
